/*
  SL — 20/10/2026 : bouton « Ajouter au panier » qui répond.
  1. Appui : le bouton s'enfonce légèrement (CSS, sl-atc.css).
  2. Appui : micro-vibration. Android : 12 ms (plage 10-20 ms recommandée par Google pour un retour de bouton).
     iPhone (iOS 18+) : retour haptique natif de Safari via un interrupteur invisible. Ailleurs : rien.
  3. Ajout réussi : « Ajouté · 105 cm » remonte dans le bouton avec une coche qui se dessine, 1,5 s.
  4. Ajout réussi : la pastille du panier rebondit et l'icône se balance.
  5. Le tiroir panier ne s'ouvre plus à l'ajout (option prévue par le thème Impact : blockCartDrawerOpening).
     Pour le rétablir, passer OPEN_DRAWER à true.
*/
(function () {
  if (window.slAtcLoaded) return;
  window.slAtcLoaded = true;

  var OPEN_DRAWER = false;
  var DONE_MS = 1500;
  var VIBRATE_MS = 12;

  var LABELS = { fr: 'Ajouté', en: 'Added', de: 'Hinzugefügt', es: 'Añadido', it: 'Aggiunto', pt: 'Adicionado', nl: 'Toegevoegd' };
  var LIVE = { fr: 'Ajouté au panier', en: 'Added to cart', de: 'In den Warenkorb gelegt', es: 'Añadido al carrito', it: 'Aggiunto al carrello', pt: 'Adicionado ao carrinho', nl: 'Toegevoegd aan winkelwagen' };
  var lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var label = LABELS[lang] || LABELS.en;

  var hapticLabel = null;
  function haptic() {
    try {
      if (typeof navigator.vibrate === 'function') {
        navigator.vibrate(VIBRATE_MS);
        return;
      }
      if (!hapticLabel) {
        hapticLabel = document.createElement('label');
        hapticLabel.setAttribute('aria-hidden', 'true');
        hapticLabel.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;';
        var input = document.createElement('input');
        input.type = 'checkbox';
        input.setAttribute('switch', '');
        input.tabIndex = -1;
        hapticLabel.appendChild(input);
        document.body.appendChild(hapticLabel);
      }
      hapticLabel.click();
    } catch (e) {}
  }

  var live = null;
  function announce(text) {
    if (!live) {
      live = document.createElement('div');
      live.setAttribute('role', 'status');
      live.className = 'sr-only';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 50);
  }

  function isProductFormButton(btn) {
    return btn && btn.type === 'submit' && btn.form && btn.form.getAttribute('is') === 'product-form';
  }

  function prepare(btn) {
    if (!isProductFormButton(btn) || btn.querySelector('.sl-atc__done')) return;
    btn.classList.add('sl-atc');
    var done = document.createElement('span');
    done.className = 'sl-atc__done';
    done.setAttribute('aria-hidden', 'true');
    done.innerHTML = '<span class="sl-atc__inner"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19.5 7" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="sl-atc__text"></span></span>';
    btn.appendChild(done);
  }

  function prepareAll() {
    document.querySelectorAll('button[type="submit"]').forEach(prepare);
  }

  function showDone(btn, variantTitle) {
    prepare(btn);
    var text = btn.querySelector('.sl-atc__text');
    if (!text) return;
    var suffix = variantTitle && /\d/.test(variantTitle) ? ' · ' + variantTitle : '';
    text.textContent = label + suffix;
    clearTimeout(btn.slAtcTimer);
    clearTimeout(btn.slAtcReset);
    btn.classList.remove('sl-atc--leaving');
    btn.classList.add('sl-atc--done');
    btn.classList.remove('sl-atc--pending');
    btn.slAtcTimer = setTimeout(function () {
      btn.classList.add('sl-atc--leaving');
      btn.slAtcReset = setTimeout(function () {
        btn.classList.remove('sl-atc--done', 'sl-atc--leaving');
      }, 260);
    }, DONE_MS);
  }

  function bumpCart() {
    document.querySelectorAll('cart-count').forEach(function (count) {
      var el = count.parentElement;
      if (!el) return;
      el.classList.remove('sl-bump');
      void el.offsetWidth;
      el.classList.add('sl-bump');
    });
    document.querySelectorAll('a[aria-controls="cart-drawer"] > svg, a[href$="/cart"] > svg').forEach(function (el) {
      el.classList.remove('sl-wiggle');
      void el.getBoundingClientRect();
      el.classList.add('sl-wiggle');
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.getAttribute('is') !== 'product-form') return;
    var btn = event.submitter && isProductFormButton(event.submitter) ? event.submitter : form.querySelector('button[type="submit"]');
    form.slAtcButton = btn;
    prepare(btn);
    if (btn) {
      btn.classList.add('sl-atc--pending');
      clearTimeout(btn.slAtcPending);
      btn.slAtcPending = setTimeout(function () { btn.classList.remove('sl-atc--pending'); }, 6000);
    }
    haptic();
  }, true);

  document.addEventListener('cart:error', function () {
    document.querySelectorAll('.sl-atc--pending').forEach(function (b) { b.classList.remove('sl-atc--pending'); });
  });

  document.addEventListener('variant:add', function (event) {
    if (!OPEN_DRAWER && event.detail) event.detail.blockCartDrawerOpening = true;
    var form = event.target && event.target.getAttribute && event.target.getAttribute('is') === 'product-form' ? event.target : null;
    var btn = form && (form.slAtcButton || form.querySelector('button[type="submit"]'));
    var items = event.detail && event.detail.items;
    var item = Array.isArray(items) ? items[0] : items;
    var variantTitle = item && item.variant_title ? item.variant_title : '';
    if (btn) showDone(btn, variantTitle);
    announce(LIVE[lang] || LIVE.en);
  }, true);

  /* Correctif Impact : si le header est masqué au scroll au moment de l'ajout, la pastille reste invisible
     alors que le panier n'est plus vide (innerText vide quand visibility:hidden). On la rend visible. */
  function syncCounts(count) {
    if (!(count > 0)) return;
    document.querySelectorAll('cart-count').forEach(function (el) {
      if (parseFloat(getComputedStyle(el).opacity) === 0) el.style.opacity = '1';
    });
  }

  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart) setTimeout(function () { syncCounts(cart.item_count); }, 450);
    if (event.detail && event.detail.baseEvent === 'variant:add') setTimeout(bumpCart, 60);
  });

  document.addEventListener('product:rerender', function () { setTimeout(prepareAll, 0); });
  document.addEventListener('variant:change', function () { setTimeout(prepareAll, 0); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareAll);
  } else {
    prepareAll();
  }
})();
